import { isLocalDev } from 'env';

import { logToDatadog } from '../datadog-logging';

type LogTypes = 'error' | 'info' | 'warn' | 'debug';
const logWithLevel =
    (type: LogTypes) =>
    (message: any, ...rest: any) => {
        if (isLocalDev) {
            // eslint-disable-next-line no-console
            console[type](message, ...rest);
        } else {
            logToDatadog(type, message, ...rest);
        }
    };

export const logger = {
    error: logWithLevel('error'),
    info: logWithLevel('info'),
    debug: logWithLevel('debug'),
    warn: logWithLevel('warn'),
};
